/** Tiny className combiner (clsx re-export under a short name). */
import clsx, { type ClassValue } from 'clsx';

export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
